import { oc } from '@orpc/contract';
import { estimateDetailSchema, updateEstimateInputSchema } from '../schemas/estimates.schemas.js';
/**
 * PATCH semantics with `expectedRevision`: an absent key is left alone, an explicit `null` clears the
 * column, and a revision that no longer matches is a 409 the page recovers from by refetching
 * (plan §2.3). Every save re-runs the valuation and re-derives the status (plan §5.6).
 */
export const updateEstimateContract = oc
    .route({
    method: 'PATCH',
    path: '/estimates/{estimateId}',
    tags: ['Estimates'],
    summary: 'Update the customer, the vehicle facts and the commercial inputs',
})
    .input(updateEstimateInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=update-estimate.contract.js.map